import "./About.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import OurApproach from "./sections/OurApproach";
import LeadershipTeam from "./sections/LeadershipTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <OurStory />
      <OurApproach />
      <LeadershipTeam />
      <Footer />
    </div>;
}